import styled from "styled-components";

export const ContainerRankingPersons = styled.div`
    display: flex;
    flex-direction: row;
    gap: 30px;
    flex-wrap: wrap;
    @media (max-width: 800px){
        flex-direction: column;
    }
`

export const ContainerExpirationPanels = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 24px;
    width: 100%;
    min-width: 0;
    @media (max-width: 1100px){
        grid-template-columns: minmax(0, 1fr);
    }
`
